import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { EntityFormMode } from '@/common/entityFramework/enumerations/EntityFormMode';
import { useForm } from '@/common/form/FormContext';
import { EntitySelect } from '@/common/form/formFields/EntitySelect';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useEffect, useMemo } from 'react';

export const ProdPricePeriodSelect = ({ priceTypeToPeriodicity, fieldDef }) => {
  const { formValues, assignValue } = useForm();
  const { entityFormMode } = useEntityMgr(); 

  // Whenever the priceType changes, clear out the old periodId
  useEffect(() => {
    if (entityFormMode !== EntityFormMode.ADD) return;
    assignValue('periodId', null);
    assignValue('periodCode', null);
  }, [formValues.priceType]);

  // Compute the periodicity lookup once per priceType
  const periodicity =
    formValues.priceType != null
      ? priceTypeToPeriodicity[formValues.priceType]
      : undefined;

  const updatedFieldDef = useMemo(() => {
    const expr =
      periodicity != null
        ? ExprUtils.whereParams('periodicity', periodicity)
        : undefined;

    return {
      ...fieldDef,
      expr,
      disabled: periodicity == null || entityFormMode !== EntityFormMode.ADD, // disable if no valid mapping
      required: periodicity != null,
    };
  }, [fieldDef, periodicity]);

  return <EntitySelect fieldDef={updatedFieldDef} />;
};